import useColumnLocation from "../hooks/use-column-location";

export default function WhenInTableBody({children}) {

    const location = useColumnLocation();

    return location === 'cell' ? children : null;
}
